// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'galaxy';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinejoin='round'>
    <g strokeLinecap='round'>
      <path d='M8.823 14.564c4.498 0 8.146-2.282 8.146-5.097 0-2.814-3.188-5.095-8.146-5.095-2.833 0-4.958 2.351-3.896 4.311' />
      <path d='M9.177 2.02c-4.497 0-8.146 2.28-8.146 5.095s3.188 5.096 8.146 5.096c2.833 0 4.958-2.352 3.896-4.312' />
      <path fill='currentColor' d='M9 10.063A1.77 1.77 0 1 0 9 6.52a1.77 1.77 0 0 0 0 3.542z' />
    </g>
    <path d='M16.083 2.27a.354.354 0 1 1 0-.708m0 .708a.354.354 0 0 0 0-.708m-.708 14.168a.354.354 0 0 1 0-.71m0 .71a.354.354 0 0 0 0-.71m-9.917 1.949a.354.354 0 0 1 0-.709m0 .709a.354.354 0 0 0 0-.709M1.74 13.781a.354.354 0 0 1 0-.708m0 .708a.354.354 0 0 0 0-.708M1.385 1.74a.354.354 0 1 1 0-.709m0 .709a.354.354 0 1 0 0-.709' />
  </g>
);

export const viewBox = '0 0 18 18';
